// src/pages/ShopByCategory.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ShopByCategory.css';

const ShopByCategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-shop-by-category.php');
      const data = await response.json();
      if (data.success) {
        setCategories(data.categories || []);
      }
    } catch (error) {
      console.error('Error loading shop-by-category data:', error);
    } finally {
      setLoading(false);
    }
  };

  /*
  if (loading) {
    return (
      <section className="shop-by-category">
        <div className="shop-by-category-container">
          <div className="shop-by-category-header">
            <h2>Shop by Category</h2>
            <p>Find the look that fits your day.</p>
          </div>
          <div className="shop-by-category-grid">
            {[1, 2, 3, 4].map((n) => (
              <div key={n} className="category-card category-card-skeleton"></div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (categories.length === 0) {
    return null;
  }
  */
  if (loading) {
    return null;
  }

  return (
    <section className="shop-by-category">
      <div className="shop-by-category-container">
        <div className="shop-by-category-header">
          <h2>Shop by Category</h2>
          <p>Find the look that fits your day.</p>
        </div>

        <div className="shop-by-category-grid">
          {categories.map((cat) => (
            <Link to={`/shop?category=${cat.slug}`} key={cat.category} className="category-card">
              {cat.image ? (
                <img src={cat.image} alt={cat.label} className="category-card-image" loading="lazy" />
              ) : (
                <div className="category-card-image category-card-fallback" />
              )}
              <div className="category-card-overlay"></div>
              <div className="category-card-content">
                <h3>{cat.label}</h3>
                {cat.description && <p className="category-card-description">{cat.description}</p>}
                <span className="shop-now">
                  {cat.button_text || 'Shop Now'}
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopByCategory;